import i18n from "@/i18n.js";

const state = {
  list: [],
  selectedCloudKey: null,
};

const getters = {
  keys: (state) => state.list,
  selectedCloudKey: (state) => state.selectedCloudKey,
};

const actions = {
  async fetchCustomerCloudKeys({ commit }, { id }) {
    const response = await this._vm.$http.get(`/restapi/users/${id}/cloudkeys`);

    commit("setCloudKeys", response.data);
  },

  async fetchCustomerCloudKey({ commit }, { id, cloudKeyId }) {
    const response = await this._vm.$http.get(
      `/restapi/users/${id}/cloudkeys/${cloudKeyId}`
    );

    commit("setSelectedCloudKey", response.data);
  },

  async createCustomerCloudKey({ commit, dispatch }, { id, body }) {
    try {
      const response = await this._vm.$http.post(
        `/restapi/users/${id}/cloudkeys`,
        body
      );

      dispatch(
        "toast/displayToast",
        {
          title: i18n.t("Success"),
          message: "Cloud Key added",
          duration: 5000,
          variant: "success",
        },
        { root: true }
      );

      commit("addCloudKey", response.data);
    } catch (err) {
      dispatch(
        "toast/displayToast",
        {
          title: "Error",
          message: err.message,
          duration: 5000,
          variant: "danger",
        },
        { root: true }
      );
    }
  },

  async updateCustomerCloudKey({ commit }, { id, cloudKeyId, body }) {
    const response = await this._vm.$http.post(
      `/restapi/users/${id}/cloudkeys/${cloudKeyId}`,
      body
    );

    const index = state.list.findIndex(
      (whitelistEntry) => whitelistEntry.id === response.data.id
    );
    if (index === -1) {
      commit("addCloudKey", response.data);
    } else {
      commit("updateCloudKey", {
        idx: index,
        cloudKey: response.data,
      });
      commit("updateCloudKeys", response.data);
    }
  },

  async deleteCustomerCloudKeys({ commit }, { userId, cloudKeys }) {
    const req = {};

    for (const cloudKey of cloudKeys) {
      req[`${cloudKey.id}`] = {
        method: "delete",
        path: `/users/${userId}/cloudkeys/${cloudKey.id}`,
      };
    }

    const res = await this._vm.$http.post("/restapi/batch", req);
    const ids = Object.keys(res.data).map((item) => +item);
    commit("deleteCloudKey", ids);
  },
};

const mutations = {
  setCloudKeys: (state, data) => (state.list = data.data),
  setSelectedCloudKey: (state, data) => {
    // debugger;
    return (state.selectedCloudKey = data);
  },
  addCloudKey: (state, data) => state.list.push(data),
  updateCloudKey: (state, data) => (state.list[`${data.idx}`] = data.cloudKey),
  deleteCloudKey(state, cloudKeys) {
    for (const cloudKey of cloudKeys) {
      state.list = state.list.filter(
        (stateCloudKey) => stateCloudKey.id !== cloudKey
      );
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
